{
  "modal_message": "グッチのアプリをお持ちですか？",
  "modal_yes": "はい",
  "modal_no": "いいえ"
}
